import React, { useState } from 'react'
import axios from 'axios'
import OrganizationForm from './OrganizationForm'
import { t } from '../../i18n'
import SectionTitle from '../shared/sectionTitle'

const CreateOrganizationForm: React.FC = () => {

  const [organization, setOrganization] = useState({
    name: '',
    code: '',
    address: '',
    order_providers_attributes: []
  })
  const [saveSuccessful, setSaveSuccessful] = useState<boolean | null>(null)
  const [saveText, setSaveText] = useState('')

  const handleSubmit = (organization, onFinished) => {
    axios
      .post('/admin/organizations', organization)
      .then((resp) => {
        setSaveSuccessful(true)
        setSaveText(t('save_successful', { scope: 'organizations' }))
        onFinished(true, null)
        setOrganization(resp.data)
        window.location.href = '/admin/organizations'
      })
      .catch((error) => {
        setSaveSuccessful(false)
        setSaveText(t('save_failed', { scope: 'organizations' }))
        onFinished(false, error.response.data)
      })
  }

  const renderSaveMessage = () => {
    if (saveText) {
      return (
        <div
          className={`alert alert-${saveSuccessful ? 'success' : 'danger'}`}
          role="alert"
        >
          {saveText}
        </div>
      )
    }
  }

  return (
    <>
      <div className="mb-3 d-flex justify-content-between align-items-center">
        <SectionTitle rows={['New', t('organizations.organization')]} />
      </div>
      <div className="card card-robis">
        <div className="row">
          <div className="col-sm-12">
            {renderSaveMessage()}
            <OrganizationForm
              organization={organization}
              onSubmitForm={handleSubmit}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default CreateOrganizationForm
